   /*==========================================================================================================
  FILTERS
  ==========================================================================================================*/
   angular
    .module('vppApp')

    .filter('italics', function() {
      return function (input) {
          var italWords = /^(for Friends)$/i;

          return input.replace(/(for Friends)/,'<i>$1<\/i>'); 

      }

  });
